// generated with @7nohe/openapi-react-query-codegen@1.6.2
import { ConfigurationService } from "../requests/services.gen";
import {
  ConfiguratorBody,
  ConfiguratorEdit,
  ConfiguratorProBody,
  ConfiguratorStandardBody,
  EmailRequest,
  LineItemBody,
  LineItemExtendedDataBody,
  LineItemUpdateBody,
  ProductRequestBody,
  QuoteExtendedDataBody,
  ShoppingCartExcelBody,
  ShoppingCartShow,
} from "../requests/types.gen";

import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query";

import * as Common from "./common";

/**
 * Returns the number of positions in a quote for a given user session ID.
 * @param data The data for the request.
 * @param data.userSessionId The user session ID.
 * @param data.localeId
 * @param data.userToken
 * @returns number OK
 * @throws ApiError
 */
export const useConfigurationServiceGetCustomApiConfigurationPublicShoppingCartPositionsCount =
  <
    TData =
      Common.ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartPositionsCountDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      localeId,
      userSessionId,
      userToken,
    }: {
      localeId?: string | undefined;
      userSessionId?: string | undefined;
      userToken?: string | undefined;
    } = {},
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseConfigurationServiceGetCustomApiConfigurationPublicShoppingCartPositionsCountKeyFn(
          { localeId, userSessionId, userToken },
          queryKey,
        ),
      queryFn: () =>
        ConfigurationService.getCustomApiConfigurationPublicShoppingCartPositionsCount(
          { localeId, userSessionId, userToken },
        ) as TData,
      ...options,
    });
/**
 * Get shopping cart extended data.
 * @param data The data for the request.
 * @param data.quoteId
 * @param data.userSessionId
 * @param data.userToken
 * @returns QuoteExtendedData OK
 * @throws ApiError
 */
export const useConfigurationServiceGetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedData =
  <
    TData =
      Common.ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      quoteId,
      userSessionId,
      userToken,
    }: {
      quoteId: string;
      userSessionId?: string | undefined;
      userToken?: string | undefined;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseConfigurationServiceGetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataKeyFn(
          { quoteId, userSessionId, userToken },
          queryKey,
        ),
      queryFn: () =>
        ConfigurationService.getCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedData(
          { quoteId, userSessionId, userToken },
        ) as TData,
      ...options,
    });
/**
 * Get line item extended data.
 * @param data The data for the request.
 * @param data.lineItemId
 * @param data.userSessionId
 * @param data.userToken
 * @returns LineItemExtendedData OK
 * @throws ApiError
 */
export const useConfigurationServiceGetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedData =
  <
    TData =
      Common.ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      lineItemId,
      userSessionId,
      userToken,
    }: {
      lineItemId: string;
      userSessionId?: string | undefined;
      userToken?: string | undefined;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseConfigurationServiceGetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataKeyFn(
          { lineItemId, userSessionId, userToken },
          queryKey,
        ),
      queryFn: () =>
        ConfigurationService.getCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedData(
          { lineItemId, userSessionId, userToken },
        ) as TData,
      ...options,
    });
/**
 * Hello world for testing and healh checks
 * @returns unknown OK
 * @throws ApiError
 */
export const useConfigurationServiceGetCustomApiConfigurationPublicHelloWorld =
  <
    TData =
      Common.ConfigurationServiceGetCustomApiConfigurationPublicHelloWorldDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseConfigurationServiceGetCustomApiConfigurationPublicHelloWorldKeyFn(
          queryKey,
        ),
      queryFn: () =>
        ConfigurationService.getCustomApiConfigurationPublicHelloWorld() as TData,
      ...options,
    });
/**
 * Start configuration session for arbitrary CFG objects
 *     {
 * "localeID": "de-DE",
 * "userToken": "",
 * "userSessionID": "exampleSessionID",
 * "cfgObjectID": "CFG_KONFIG_STANDARD",
 * "externalId": "exampleID",
 * "callbackUrl": "exampleURL",
 * "geolocationId": "DE"
 * }
 * @param data The data for the request.
 * @param data.requestBody
 * @returns RedirectResponse OK
 * @throws ApiError
 */
export const useConfigurationServicePostCustomApiConfigurationPublicStartConfigurator =
  <
    TData =
      Common.ConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody?: ConfiguratorBody | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody?: ConfiguratorBody | undefined;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        ConfigurationService.postCustomApiConfigurationPublicStartConfigurator({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * Start configuration session for a STANDARD_CFG Konfiguration
 * (parameters tailored for the STANDARD_CFG case)
 *     {
 * "localeID": "de-DE",
 * "userToken": "",
 * "userSessionID": "exampleSessionID",
 * "externalId": "exampleID",
 * "geolocationId": "DE"
 * }
 * @param data The data for the request.
 * @param data.requestBody
 * @returns RedirectResponse OK
 * @throws ApiError
 */
export const useConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandard =
  <
    TData =
      Common.ConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandardMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody?: ConfiguratorStandardBody | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody?: ConfiguratorStandardBody | undefined;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        ConfigurationService.postCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandard(
          { requestBody },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * Start configuration session for a CFG_PROFI_CONFIGRATION Konfiguration (ie. SDT / SRT)
 *     {
 * "localeID": "de-DE",
 * "userToken": "",
 * "userSessionID": "exampleSessionID",
 * "productSegment": "SRT",
 * "geolocationId": "DE"
 * }
 * @param data The data for the request.
 * @param data.requestBody
 * @returns RedirectResponse OK
 * @throws ApiError
 */
export const useConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfigurator =
  <
    TData =
      Common.ConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody?: ConfiguratorProBody | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody?: ConfiguratorProBody | undefined;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        ConfigurationService.postCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfigurator(
          { requestBody },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * Start configuration session for a CFG_PROFI_CONFIGRATION SCNELL Konfiguration (ie. SDT / SRT)
 *     {
 * "localeID": "de-DE",
 * "userToken": "",
 * "userSessionID": "exampleSessionID",
 * "productSegment": "SRT",
 * "geolocationId": "DE"
 * }
 * @param data The data for the request.
 * @param data.requestBody
 * @returns RedirectResponse OK
 * @throws ApiError
 */
export const useConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnell =
  <
    TData =
      Common.ConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnellMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody?: ConfiguratorProBody | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody?: ConfiguratorProBody | undefined;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        ConfigurationService.postCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnell(
          { requestBody },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * Adds the configuration session ID to the user's shopping cart using their session ID.
 * @param data The data for the request.
 * @param data.requestBody The line item body containing the product details.
 * @returns QuoteResponse OK
 * @throws ApiError
 */
export const useConfigurationServicePostCustomApiConfigurationPublicShoppingCartConfigurations =
  <
    TData =
      Common.ConfigurationServicePostCustomApiConfigurationPublicShoppingCartConfigurationsMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody?: LineItemBody | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody?: LineItemBody | undefined;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        ConfigurationService.postCustomApiConfigurationPublicShoppingCartConfigurations(
          { requestBody },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * Edits a configuration that was previously added to the shopping cart.
 * @param data The data for the request.
 * @param data.requestBody The line item body containing the product details.
 * @returns RedirectResponse OK
 * @throws ApiError
 */
export const useConfigurationServicePostCustomApiConfigurationPublicShoppingCartConfigurationsEdit =
  <
    TData =
      Common.ConfigurationServicePostCustomApiConfigurationPublicShoppingCartConfigurationsEditMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody?: ConfiguratorEdit | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody?: ConfiguratorEdit | undefined;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        ConfigurationService.postCustomApiConfigurationPublicShoppingCartConfigurationsEdit(
          { requestBody },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * Returns URL to show the current Shoppingcart for the userSessionId.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns RedirectResponse OK
 * @throws ApiError
 */
export const useConfigurationServicePostCustomApiConfigurationPublicShoppingCartShow =
  <
    TData =
      Common.ConfigurationServicePostCustomApiConfigurationPublicShoppingCartShowMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody?: ShoppingCartShow | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody?: ShoppingCartShow | undefined;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        ConfigurationService.postCustomApiConfigurationPublicShoppingCartShow({
          requestBody,
        }) as unknown as Promise<TData>,
      ...options,
    });
/**
 * This endpoint adds a product from the request body to the shopping cart that belongs to the user session ID.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns QuoteResponse OK
 * @throws ApiError
 */
export const useConfigurationServicePostCustomApiConfigurationPublicShoppingCartProducts =
  <
    TData =
      Common.ConfigurationServicePostCustomApiConfigurationPublicShoppingCartProductsMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody?: ProductRequestBody | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody?: ProductRequestBody | undefined;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        ConfigurationService.postCustomApiConfigurationPublicShoppingCartProducts(
          { requestBody },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * Generate a shopping cart Excel report.
 * @param data The data for the request.
 * @param data.quoteId Shopping cart quote guid
 * @param data.requestBody Contains sessionId and excel header values
 * @returns unknown OK
 * @throws ApiError
 */
export const useConfigurationServicePostCustomApiConfigurationPublicShoppingCartByQuoteIdExcel =
  <
    TData =
      Common.ConfigurationServicePostCustomApiConfigurationPublicShoppingCartByQuoteIdExcelMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          quoteId: string;
          requestBody?: ShoppingCartExcelBody | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        quoteId: string;
        requestBody?: ShoppingCartExcelBody | undefined;
      },
      TContext
    >({
      mutationFn: ({ quoteId, requestBody }) =>
        ConfigurationService.postCustomApiConfigurationPublicShoppingCartByQuoteIdExcel(
          { quoteId, requestBody },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * Sends a quote request e-mail from the customer.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const useConfigurationServicePostCustomApiConfigurationPublicShoppingCartQuoteRequestMail =
  <
    TData =
      Common.ConfigurationServicePostCustomApiConfigurationPublicShoppingCartQuoteRequestMailMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          requestBody?: EmailRequest | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        requestBody?: EmailRequest | undefined;
      },
      TContext
    >({
      mutationFn: ({ requestBody }) =>
        ConfigurationService.postCustomApiConfigurationPublicShoppingCartQuoteRequestMail(
          { requestBody },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * @param data The data for the request.
 * @param data.lineItemId
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const useConfigurationServicePutCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemId =
  <
    TData =
      Common.ConfigurationServicePutCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemIdMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          lineItemId: string;
          requestBody?: LineItemUpdateBody | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        lineItemId: string;
        requestBody?: LineItemUpdateBody | undefined;
      },
      TContext
    >({
      mutationFn: ({ lineItemId, requestBody }) =>
        ConfigurationService.putCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemId(
          { lineItemId, requestBody },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * Update shopping cart extended data.
 * @param data The data for the request.
 * @param data.quoteId
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const useConfigurationServicePutCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedData =
  <
    TData =
      Common.ConfigurationServicePutCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          quoteId: string;
          requestBody?: QuoteExtendedDataBody | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        quoteId: string;
        requestBody?: QuoteExtendedDataBody | undefined;
      },
      TContext
    >({
      mutationFn: ({ quoteId, requestBody }) =>
        ConfigurationService.putCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedData(
          { quoteId, requestBody },
        ) as unknown as Promise<TData>,
      ...options,
    });
/**
 * Update line item cart extended data.
 * @param data The data for the request.
 * @param data.lineItemId
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const useConfigurationServicePutCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedData =
  <
    TData =
      Common.ConfigurationServicePutCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataMutationResult,
    TError = unknown,
    TContext = unknown,
  >(
    options?: Omit<
      UseMutationOptions<
        TData,
        TError,
        {
          lineItemId: string;
          requestBody?: LineItemExtendedDataBody | undefined;
        },
        TContext
      >,
      "mutationFn"
    >,
  ) =>
    useMutation<
      TData,
      TError,
      {
        lineItemId: string;
        requestBody?: LineItemExtendedDataBody | undefined;
      },
      TContext
    >({
      mutationFn: ({ lineItemId, requestBody }) =>
        ConfigurationService.putCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedData(
          { lineItemId, requestBody },
        ) as unknown as Promise<TData>,
      ...options,
    });
